import { Snackbar, Alert } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { IRootState } from '../../types/store';
import { hideNotification } from '../../store/Reducers/NotificationSnackbarSlice';

export const GlobalNotification = () => {
  const dispatch = useDispatch();
  const { isOpen, message, severity } = useSelector(
    (state: IRootState) => state.notificationSnackbar,
  );

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={4000} // auto-hide after 4s
      onClose={() => dispatch(hideNotification())}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity={severity} onClose={() => dispatch(hideNotification())} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};
